export default __webpack_public_path__ + "static/media/blog2_image.74e7957a.png";